const NotificationType = Object.freeze({
    THRESHOLD_LIMIT: 0,
    DELAYED_TEST: 1
})

export default NotificationType